<template>
    <p>To make it clearer, this chart is only editable when viewed with no increases added and not being shown in today's
        money.</p>
    <p>Do you want to switch to this view so you can edit any particular year?</p>

    <div class="d-flex justify-content-end">
        <button ref="btnYes" type="button" class="btn btn-primary mb-3" @click="emit('editModeRequired')">Yes</button>
        <button type="button" class="btn btn-secondary mb-3 ms-2" @click="emit('cancelled')">No</button>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const emit = defineEmits({
    'cancelled': null,
    'editModeRequired': null
});

const btnYes = ref(null);

</script>
